import React from "react";
import Select from "react-select";
import { SubmittingProvider } from "../../types/SubmittingProvider";
import { sweetalert } from "../../App";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import { buildRow, getBoolSelectOptions, getBoolSelectVal, getLabel} from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";
import AutoComplete from "../admin/Autocomplete";
import PhoneInput from 'react-phone-number-input'
import CustomSelect from "../form/CustomSelect";
import CustomInput from "../form/CustomInput";
import CustomPhone from "../form/CustomPhone";
import { reverse } from "dns";
// import GetField from "../../customfields/GetField";
// import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";

interface ProviderManagementState {
  selectedProvider: SubmittingProvider
  providerSearchAddress: string
  providerStateLabel?: { label: any, value: any} | string // This is used to display the state label in the select dropdown
  selectedFacilityIDLabel? // This is used to display the selected facility in the select dropdown
  // customFieldData?
}
interface ProviderManagementProps {
  selectedProvider
  states: { value: string, label: string }[]
  facilities: {}[]
  facilityLabels: { value: string, label: string }[]
  onSubmit?
  // pageCustomQuestions?
}

export class ProviderManagementModal extends React.Component<ProviderManagementProps, ProviderManagementState> {
  public static ID = "providermanagement";
  constructor(props) {
    super(props);
    this.state = {
      selectedProvider: {
        ID: null,
        FullName: "",
        ContactID: "",
        NPI_Number: "",
        FacilityID: null,
        Address: "",
        Address_A: "",
        City: "",
        State: "",
        Zip: "",
        Phone: "",
        CreatedBy: "",
        CreatedDate: new Date(),
        UpdatedBy: "",
        UpdatedDate: null
      } as SubmittingProvider,
      providerSearchAddress: "",
    } as ProviderManagementState;
  }

  componentDidMount(): void {
    $(`#${ProviderManagementModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
  }

  componentWillReceiveProps(nextProps: Readonly<ProviderManagementProps>, nextContext: any) {
    if (!isEmptyObject(nextProps.selectedProvider)) {
      let result = nextProps.selectedProvider;
      this.setState({
        selectedProvider: {
          ID: result.ID ? result.ID : null,
          FullName: result.FullName ? result.FullName : "",
          ContactID: result.ContactID ? result.ContactID : "",
          NPI_Number: result.NPI_Number ? result.NPI_Number : "",
          FacilityID: result.FacilityID ? result.FacilityID : null,
          Address: result.Address ? result.Address : "",
          Address_A: result.Address_A ? result.Address_A : "",
          City: result.City ? result.City : "",
          State: result.State ? result.State : "",
          Zip: result.Zip ? result.Zip : "",
          Phone: result.Phone ? result.Phone : "",
          CreatedBy: result.CreatedBy ? result.CreatedBy : "",
          CreatedDate: result.CreatedDate ? result.CreatedDate : new Date(),
          UpdatedBy: result.UpdatedBy ? result.UpdatedBy : "",
          UpdatedDate: result.UpdatedDate ? result.UpdatedDate : null,
        } as SubmittingProvider,
        providerStateLabel: result && result.State ? getLabel(result.State, this.props.states) : "",
        selectedFacilityIDLabel: result && result.FacilityID ? getLabel(result.FacilityID, this.props.facilityLabels) : "",
      });
    }
  }

  handleDateOnChange(value, state) {
    if (value) {
      this.setState((prevState) => ({
        selectedProvider: {
          ...prevState.selectedProvider,
          [state]: value,
        },
      }));
    } else {
      this.setState((prevState) => ({
        selectedProvider: {
          ...prevState.selectedProvider,
          [state]: null,
        },
      }));
    }
  }

  handleStateChange(e, stateLabelToSet, stateToSet) {
    this.setState((prevState) => ({
      selectedProvider: {
        ...prevState.selectedProvider,
        [stateLabelToSet]: e,
        [stateToSet]: e.value,
      },
      providerStateLabel: e,
    }));
  }

  handleChange(e, stateToSet, stateLabelToSet = '', type = 'input') {
    if (type === 'select') {
      if (stateToSet === "State") {
        this.handleStateChange(e, stateLabelToSet, stateToSet)
      }
    } else {
      this.setState((prevState) => ({
        selectedProvider: {
          ...prevState.selectedProvider,
          [stateLabelToSet]: e,
          [stateToSet]: e.value ? e.value : e.target.value, // If it's a select, use the value, otherwise use the input value
        },
      }));
    }
  }

  render() {
    return (
      <div className="modal fade form_modal" id={ProviderManagementModal.ID} tabIndex={-1} role="dialog"
        aria-labelledby="provider_modal_label"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="provider_modal_label">Provider Management</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() =>
                    this.setState({
                      selectedProvider: {
                        ID: null,
                        FullName: "",
                        ContactID: "",
                        NPI_Number: "",
                        FacilityID: null,
                        Address: "",
                        Address_A: "",
                        City: "",
                        State: "",
                        Zip: "",
                        Phone: "",
                        CreatedBy: "",
                        CreatedDate: new Date(),
                        UpdatedBy: "",
                        UpdatedDate: null
                      } as SubmittingProvider,
                      providerSearchAddress: "",
                      providerStateLabel: "",
                      selectedFacilityIDLabel: "",
                    })}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* TODO Facility should be a multi-select and saved to SubmittingProvider.FacilityIDs */}
                <div className="form-group row">
                  <label htmlFor={'Facility'} className="col-sm-4 col-form-label"
                    style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}
                  >Facility<section className="text-danger d-inline-block px-1">*</section></label>
                  <div className="col-sm-8  p-0 m-0" id={'Facility'}>
                    <Select
                      name="Facility"
                      isSearchable={true}
                      placeholder={<div className="accessibilityText">Please Select...</div>}
                      noOptionsMessage={() => "No option"}
                      className={"state_select"}
                      options={this.props.facilityLabels}
                      onChange={(e) => this.setState({ selectedFacilityIDLabel: e, selectedProvider: { ...this.state.selectedProvider, FacilityID: e.value } })}
                      value={this.state.selectedFacilityIDLabel}
                      aria-label="Facility"
                    />
                  </div>
                </div>
                {/* ContactID */}
                <div className="form-group row">
                  <label htmlFor={'Provider ContactID'}
                    className="col-sm-4 col-form-label"
                    style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}
                  >Contact ID</label>
                  <div className={"col-sm-8 p-0 m-0"}>
                    <input
                      id={'Provider ContactID'}
                      name="Provider ContactID"
                      aria-label={"Provider ContactID"}
                      className={"form-control"}
                      autoComplete={"off"}
                      type={"text"}
                      value={this.state.selectedProvider?.ContactID ? this.state.selectedProvider?.ContactID : ""}
                      readOnly={true}
                      placeholder="Auto-generated by Starlims on Create."
                    />
                  </div>
                </div>
                {/* FullName */}
                <div className="form-group row">
                  <label htmlFor={'Provider FullName'}
                    className="col-sm-4 col-form-label"
                    style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}
                  >Provider Full Name<section className="text-danger d-inline-block px-1">*</section></label>
                  <div className={"col-sm-8 p-0 m-0"}>
                    <input
                      id={'Provider FullName'}
                      name="Provider FullName"
                      aria-label={"Provider FullName"}
                      className={"form-control"}
                      autoComplete={"off"}
                      onChange={(e)=>{
                          this.setState((prevState) => ({
                            selectedProvider: {
                              ...prevState.selectedProvider,
                              FullName: e.target.value,
                            },
                          }));
                      }}
                      type={"text"}
                      value={this.state.selectedProvider?.FullName ? this.state.selectedProvider?.FullName : ""}
                      placeholder={"Enter Provider Full Name"}
                    />
                    <small className="form-text text-muted" style={{ paddingLeft: "1em" }}>Last First MI</small>
                  </div>
                </div>
                {/* NPI_Number */}
                <CustomInput fromFilterPage={false}
                  value={this.state.selectedProvider?.NPI_Number}
                  label={"NPI Number"}
                  tooltip={"The 10-digit NPI Number of the Provider"}
                  handleChange={(e) => this.handleChange(e, "NPI_Number")}
                  required={this.state.selectedProvider?.ID ? false : true}
                  placeholder={<div className="accessibilityText">10-digit NPI Number</div>}
                />
                {/* Address */}
                <div className="form-group row">
                  <label htmlFor={'SearchAddress'}
                    className="col-sm-4 col-form-label"
                    style={{ fontWeight: "bold", paddingTop: "0.5em", fontSize: "0.8em" }}
                  >Search Address</label>
                  <div className="col-sm-8  p-0 m-0" id={'SearchAddress'}>
                    <AutoComplete key={`ProviderAddressautocomplete`} id={`ProviderAddressautocomplete`}
                      onChange={(addr) => {
                        this.setState((prevState) => ({ providerSearchAddress: addr }))
                      }}
                      value={this.state.providerSearchAddress}
                      updateFormData={(addr, addr2, city, state, zip, county, country) => {
                        let addressData = {Address: "", Address_A: "", City: "", State: "", Zip: ""};
                        let stateLabel = {label: "",value:""}

                        addressData.Address = addr;
                        addressData.Address_A = addr2;
                        addressData.City = city;
                        addressData.State = state;
                        addressData.Zip = zip;

                        stateLabel = getLabel(state, this.props.states);
                        this.setState((prevState) => ({
                          selectedProvider: {
                            ...prevState.selectedProvider,
                            ...addressData,
                          },
                          providerStateLabel: stateLabel,
                        }));
                      }}
                    />
                  </div>
                </div>
                <CustomInput fromFilterPage={false}
                  value={this.state.selectedProvider?.Address}
                  label={"Provider Address"}
                  tooltip={"The street address of the Provider"}
                  handleChange={(e) => this.handleChange(e, "Address")}
                  required={this.state.selectedProvider?.ID ? false : true}
                />
                <CustomInput fromFilterPage={false}
                  value={this.state.selectedProvider?.Address_A}
                  label={"Provider Address Cont."}
                  tooltip={"The street address of the Provider continued"}
                  handleChange={(e) => this.handleChange(e, "Address_A")}
                />
                <CustomInput fromFilterPage={false}
                  value={this.state.selectedProvider?.City}
                  label={"Provider City"}
                  tooltip={"The city of the Provider's address"}
                  handleChange={(e) => this.handleChange(e, "City")}
                  required={this.state.selectedProvider?.ID ? false : true}
                />
                <CustomSelect
                  fromFilterPage={false}
                  value={this.state.providerStateLabel} label={"State"}
                  tooltip={"The state of the Provider's address"}
                  handleChange={(e) => this.handleChange(e, "State", "providerStateLabel", "select")}
                  options={this.props.states}
                  required={this.state.selectedProvider?.ID ? false : true}
                  placeholder={<div className="accessibilityText">Please Select...</div>}
                />
                <CustomInput fromFilterPage={false}
                  value={this.state.selectedProvider?.Zip}
                  label={"Provider Zip"}
                  tooltip={"The zipcode of the Provider's address"}
                  handleChange={(e) => this.handleChange(e, "Zip")}
                  required={this.state.selectedProvider?.ID ? false : true}
                />
                <CustomPhone fromFilterPage={false}
                  value={this.state.selectedProvider?.Phone}
                  label={"Phone"}
                  tooltip={`The phone number of the Provider`}
                  handleDateOnChange={(e) => this.handleDateOnChange(e, "Phone")}
                  required={this.state.selectedProvider?.ID ? false : true}
                />
                {/* Footer */}
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={() => {
                    //on edit, provider should have facility ID, Full Name
                    // NPI might be null for some providers imported from starlims
                    if (!this.state.selectedProvider?.FacilityID){
                      return sweetalert.fire("Attention", "Provider Facility cannot be empty.", "error")
                    }
                    if (isBlank(this.state.selectedProvider?.FullName) ||
                      isOnlyWhitespace(this.state.selectedProvider?.FullName)
                    ) {
                      return sweetalert.fire("Attention", "Provider Full Name cannot be empty.", "error")
                    }
                    // on edit if there is an NPI number it should be 10 digits
                    if(this.state.selectedProvider?.NPI_Number &&
                      (this.state.selectedProvider?.NPI_Number.length !== 10 || isNaN(Number(this.state.selectedProvider?.NPI_Number)))){
                      return sweetalert.fire("Attention", "Provider NPI Number must be 10 digits.", "error")
                    }
                    //on create, all fields are required
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.NPI_Number) || isOnlyWhitespace(this.state.selectedProvider?.NPI_Number)) ) {
                      return sweetalert.fire("Attention", "Provider NPI Number cannot be empty", "error")
                    }
                    if (!this.state.selectedProvider?.ID && this.state.selectedProvider?.NPI_Number &&
                      (this.state.selectedProvider?.NPI_Number.length !== 10 || isNaN(Number(this.state.selectedProvider?.NPI_Number)))) {
                      return sweetalert.fire("Attention", "Provider NPI Number must be 10 digits.", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.Address) || isOnlyWhitespace(this.state.selectedProvider?.Address))) {
                      return sweetalert.fire("Attention", "Provider Address cannot be empty", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.City) || isOnlyWhitespace(this.state.selectedProvider?.City))) {
                      return sweetalert.fire("Attention", "Provider City cannot be empty", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.State) || isOnlyWhitespace(this.state.selectedProvider?.State))) {
                      return sweetalert.fire("Attention", "Provider State cannot be empty", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.Zip) || isOnlyWhitespace(this.state.selectedProvider?.Zip))) {
                      return sweetalert.fire("Attention", "Provider Zip cannot be empty", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      // zip is not at least 5 digits
                      (this.state.selectedProvider?.Zip.length < 5 || isNaN(Number(this.state.selectedProvider?.Zip)))
                    ){
                      return sweetalert.fire("Attention", "Provider Zip should be at least 5-digits", "error")
                    }
                    if (!this.state.selectedProvider?.ID && 
                      (isBlank(this.state.selectedProvider?.Phone) || isOnlyWhitespace(this.state.selectedProvider?.Phone))) {
                      return sweetalert.fire("Attention", "Provider Phone cannot be empty", "error")
                      }

                    // let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedProvider.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedProvider)
                    // if(invalid){
                    //     return;
                    // }

                    this.props.onSubmit(this.state.selectedProvider);
                  }}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}